var reloadDelay = 2400;
var defaultAlertProgressDuration = 2000;

var NotificationApp = function () { };

NotificationApp.prototype.send =
    function (heading, body, position, loaderBgColor, icon, hideAfter, stack, showHideTransition) {
        if (!hideAfter) {
            hideAfter = defaultAlertProgressDuration;
        }
        if (!stack) {
            stack = 1;
        }

        const options = {
            heading: heading,
            text: body,
            position: position,
            loaderBg: loaderBgColor,
            icon: icon,
            hideAfter: hideAfter,
            stack: stack
        };

        if (showHideTransition) {
            options.showHideTransition = showHideTransition;
        }

        $.toast().reset('all');
        $.toast(options);
    };

$.NotificationApp = new NotificationApp, $.NotificationApp.Constructor = NotificationApp;

$.notificationAlert = function (header, message, duration) {
    $.NotificationApp.send(header, message, 'top-right', '#bf441d', 'error', duration);
};

$.notificationSuccess = function (header, message, duration) {
    $.NotificationApp.send(header, message, 'top-right', '#5ba035', 'success', duration);
};

$.notificationWarning = function (header, message, duration) {
    $.NotificationApp.send(header, message, 'top-right', '#da8609', 'warning', duration);
};

$.notificationInfo = function (header, message, duration) {
    $.NotificationApp.send(header, message, 'top-right', '#3b98b5', 'info', duration);
};

$.showNotification = function (header, message, succeed) {
    succeed === true
        ? $.notificationSuccess(header, message)
        : $.notificationAlert(header, message);
    setTimeout(function () {
        location.reload(true);
    }, reloadDelay);
};

var notifications = (function () {
    const success = function (header, message) {
        $.notificationSuccess(header, message);
    };
    const alert = function (header, message) {
        $.notificationAlert(header, message);
    };
    const warning = function (header, message) {
        $.notificationWarning(header, message);
    };
    const info = function (header, message) {
        $.notificationWarning(header, message);
    };

    return {
        success: success,
        alert: alert,
        warning: warning,
        info: info
    };

})();